import { Injectable } from '@angular/core';
import { DuplicatedDataCollections } from '@osos/shared/api';
import { DuplicatedCollectionPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class DuplicatedCollectionParserV1Service extends ParserBase<
  DuplicatedDataCollections,
  DuplicatedCollectionPresenterModel
> {
  constructor() {
    super(DuplicatedDataCollections, DuplicatedCollectionPresenterModel, 1);
  }

  override getPresenterModel(
    model: Partial<DuplicatedDataCollections>,
  ): DuplicatedCollectionPresenterModel {
    throw new Error('Method not implemented.');
  }

  getDataModel(
    presenter: DuplicatedCollectionPresenterModel,
  ): DuplicatedDataCollections {
    const model = {
      description: Object.keys(presenter.description ?? {}).every(
        (k) => !presenter.description[k],
      )
        ? undefined
        : presenter.description,
      name: presenter.name,
      icon: presenter.icon,
    } as DuplicatedDataCollections;
    return model;
  }
}
